// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-35ab2bd8]:after{content:normal}.btn-remove[data-v-35ab2bd8]:hover{cursor:pointer}.gift-options label[data-v-35ab2bd8]{margin:initial;text-align:left;width:100%}.gift-options input[data-v-35ab2bd8]{margin:3px 5px 3px 0}.product-cell-inner-wrap p[data-v-35ab2bd8]{width:100%}.form-section-container a[data-v-35ab2bd8]{display:contents;flex:1 1 150px;min-width:100px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
